import GetTdgDocumentByExternalIdRequestModelBase from '../_generated/modelBases/get-tdg-document-by-external-id-request-model-base';

export default class GetTdgDocumentByExternalIdRequestModel extends GetTdgDocumentByExternalIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
